const CTA_HOSTS = new Set([
  'app.gtowizard.com',
  'gtowizard.com',
  'www.gtowizard.com',
  'help.gtowizard.com',
  'dailydoseofgto.com',
  'www.dailydoseofgto.com'
]);

const OUTBOUND_HOSTS = new Set([
  'youtube.com',
  'www.youtube.com',
  'youtu.be',
  'discord.gg',
  'discord.com',
  'twitter.com',
  'x.com',
  'facebook.com',
  'www.facebook.com',
  'instagram.com',
  'www.instagram.com',
  'linkedin.com',
  'www.linkedin.com',
  'github.com',
  'www.github.com',
  'reddit.com',
  'www.reddit.com'
]);

const CTA_LOCATIONS = [
  { selector: '.post-promo', location: 'post_promo' },
  { selector: '.sidebar', location: 'sidebar' },
  { selector: '.features', location: 'features_section' },
  { selector: '.help-section', location: 'help_section' },
  { selector: '.daily-dose', location: 'daily_dose_section' },
  { selector: '.gh-announcement', location: 'announcement_bar' },
  { selector: 'header', location: 'header' },
  { selector: 'footer', location: 'footer' },
  { selector: '.gh-content', location: 'post_body' }
];

export function isCtaHost(host) {
  return CTA_HOSTS.has(host);
}

export function isOutboundHost(host) {
  return OUTBOUND_HOSTS.has(host);
}

export function classifyLocation(el) {
  for (const { selector, location } of CTA_LOCATIONS) {
    if (el.closest(selector)) return location;
  }
  return 'unknown';
}
